module.exports = __webpack_public_path__ + "img/logo.42b1290b.png";